import { render, staticRenderFns } from "./CourseManager.vue?vue&type=template&id=c6b785e0&scoped=true"
import script from "./CourseManager.vue?vue&type=script&lang=js"
export * from "./CourseManager.vue?vue&type=script&lang=js"
import style0 from "./CourseManager.vue?vue&type=style&index=0&id=c6b785e0&prod&scoped=true&lang=css"
import style1 from "./CourseManager.vue?vue&type=style&index=1&id=c6b785e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b785e0",
  null
  
)

export default component.exports